import { render, staticRenderFns } from "./TabCalendar.vue?vue&type=template&id=1580904c&"
import script from "./TabCalendar.vue?vue&type=script&lang=js&"
export * from "./TabCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TabCalendar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabCalendar.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports